module.exports = __webpack_public_path__ + "img/2016-min.a47e564a.jpg";